import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	startDateNotSet: {
		id: 'software-releases-launch-card.version-dates.start-date-not-set',
		defaultMessage: 'Start date not set',
		description:
			'When the version has no start date set, this text is displayed this instead of the actual start date of this version.',
	},
	releaseDateNotSet: {
		id: 'software-releases-launch-card.version-dates.release-date-not-set',
		defaultMessage: 'Release date not set',
		description:
			'When the version has no release date set, this text is displayed this instead of the actual release date of this version.',
	},
	startDateFieldLabel: {
		id: 'software-releases-launch-card.version-dates.start-date-field-label',
		defaultMessage: 'Start date',
		description: 'Label for the start date field',
	},
	startDateGenericErrorFlagTitle: {
		id: 'software-releases-launch-card.version-dates.start-date-generic-error-flag-title',
		defaultMessage: "We couldn't update the start date",
		description: 'Flag title for failure to update version start date',
	},
	badReleaseStartDateOrderErrorFlagTitle: {
		id: 'software-releases-launch-card.version-dates.bad-release-start-date-order-error-flag-title',
		defaultMessage: 'The start date cannot be after the release date',
		description: 'Flag title for bad start/release date order error',
	},
	badReleaseStartDateOrderErrorFlagDescription: {
		id: 'software-releases-launch-card.version-dates.bad-release-start-date-order-error-flag-description',
		defaultMessage: 'Please select a different start date.',
		description: 'Flag description for bad start/release date order error',
	},
	releaseDateFieldLabel: {
		id: 'software-releases-launch-card.version-dates.release-date-field-label',
		defaultMessage: 'Release date',
		description: 'Label for the release date field',
	},
	releaseDateErrorFlagTitle: {
		id: 'software-releases-launch-card.version-dates.release-date-error-flag-title',
		defaultMessage: "We couldn't update the release date",
		description: 'Flag title for failure to update version release date',
	},
	genericErrorFlagDescription: {
		id: 'software-releases-launch-card.version-dates.generic-error-flag-description',
		defaultMessage:
			'Something went wrong. Please try again or contact your administrator if the problem persists.',
		description: 'Flag description for failure to update version start or release date',
	},
});
